import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {TranslateModule} from "@ngx-translate/core";

import {SelectLanguageComponent} from "@shared/components/select-language/select-language.component";
import {DateTimePickerModule} from "@shared/modules/material/datetime-picker.module";

import {ButtonComponent} from './components/button/button.component';
import {TimeoutDialogComponent} from './components/timeout-dialog/timeout-dialog.component';
import {ServerTimeoutDialogComponent} from './components/server-timeout-dialog/server-timeout-dialog.component';
import {OfflineDialogComponent} from './components/offline-dialog/offline-dialog.component';
import {ErrorDialogComponent} from './components/error-dialog/error-dialog.component';
import {PreventDoubleClickDirective} from './directives/prevent-double-click.directive';
import {MaterialModule} from './modules/material/material.module';
import {CloseButtonComponent} from './components/close-button/close-button.component';
import {ArrowLeftButtonComponent} from './components/arrow-left-button/arrow-left-button.component';
import {CopyToClipboardComponent} from './components/copy-to-clipboard/copy-to-clipboard.component';
import {ButtonTransparentComponent} from './components/button-transparent/button-transparent.component';

import {SecureImagePipe} from './pipes/secure-image.pipe';
import {ImageModalComponent} from './components/image-modal/image-modal.component';
import { SecondaryButtonComponent } from './components/secondary-button/secondary-button.component';
import { TkSlicePipe } from './pipes/tk-slice.pipe';
import { IconTextHoverComponent } from './components/icon-text-hover/icon-text-hover.component';
import { IfAddressIsAvailableOnThePhonePipe } from './pipes/if-address-is-available-on-the-phone.pipe';
import { ModalWrapperComponent } from './components/modal-wrapper/modal-wrapper.component';
import { TankFillPercentagePipe } from './pipes/tank-fill-percentage.pipe';
import { VehicleLocationComponent } from './components/location/vehicle-location.component';
import { SortVehicleFullListColumnsPipe } from './pipes/sort-vehicle-full-list-columns.pipe';

@NgModule({
  declarations: [
    ButtonComponent,
    TimeoutDialogComponent,
    ServerTimeoutDialogComponent,
    OfflineDialogComponent,
    ErrorDialogComponent,
    PreventDoubleClickDirective,
    CloseButtonComponent,
    ArrowLeftButtonComponent,
    CopyToClipboardComponent,
    ButtonTransparentComponent,
    SelectLanguageComponent,
    SecondaryButtonComponent,
    TkSlicePipe,
    IconTextHoverComponent,
    SecureImagePipe,
    ImageModalComponent,
    IfAddressIsAvailableOnThePhonePipe,
    ModalWrapperComponent,
    TankFillPercentagePipe,
    VehicleLocationComponent,
    SortVehicleFullListColumnsPipe,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    DateTimePickerModule,
    TranslateModule,
  ],
  exports: [
      DateTimePickerModule,
      MaterialModule,
      ButtonComponent,
      CloseButtonComponent,
      ArrowLeftButtonComponent,
      CopyToClipboardComponent,
      ButtonTransparentComponent,
      SelectLanguageComponent,
      SecondaryButtonComponent,
      TkSlicePipe,
      SecureImagePipe,
      IfAddressIsAvailableOnThePhonePipe,
      ModalWrapperComponent,
      TankFillPercentagePipe,
      VehicleLocationComponent,
      SortVehicleFullListColumnsPipe,
  ]
})
export class SharedModule {
}
